module.exports = __webpack_public_path__ + "img/132.68a53492.jpg";